import React from 'react'
import { useSelector } from 'APP/Hooks/redux'
import { FlatList } from 'react-native'
import Animated, { FadeInUp } from 'react-native-reanimated'
import AppointmentCard from 'APP/Components/AppointmentCard'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'
import I18n from 'APP/I18n'
import moment from 'moment'

const ENTERING = FadeInUp.duration(500)

const StyledTitle = styled(Typography).attrs(() => ({
  variant: 'h3',
}))`
  color: ${({ theme }) => theme.colors.text};
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

const StyledFlatList = styled(FlatList).attrs(() => ({
  contentContainerStyle: {
    paddingTop: 4,
  },
}))`
  margin-top: -4px;
`

const UpcomingAppointments = ({ style }) => {
  const appointments = useSelector((state) => state.history.appointments.upcoming)
  const fetchAppointmentsRunning = useSelector((state) => state.history.fetchAppointmentsRunning)
  const actualAppointments = appointments.filter((appointment) =>
    moment().isBefore(appointment.end_at)
  )

  if (fetchAppointmentsRunning || !actualAppointments?.length) return null

  const renderItem = ({ item }) => {
    return <AppointmentCard appointment={item} showQuickActions />
  }

  const title = I18n.t('Appointments.upcomingListTitle')

  return (
    <Animated.View style={style} entering={ENTERING}>
      <StyledTitle>{title}</StyledTitle>
      <StyledFlatList
        data={actualAppointments}
        renderItem={renderItem}
        keyExtractor={(item) => `${item.episode_id}-${item.start_at}`}
      />
    </Animated.View>
  )
}

export default UpcomingAppointments
